import { render } from "./App.vue?vue&type=template&id=79ef4148"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=79ef4148&lang=scss"

import exportComponent from "D:\\Projects\\freelance\\admingypsy-new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__